module.exports = __webpack_public_path__ + "img/雷平@2x.6c7fe0ac.png";